import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AbstractFormElement } from '../abstract-form-element';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { FormElementComponent } from '../form-element/form-element.component';

@Component({
  selector: 'app-form-switch',
  templateUrl: './form-switch.component.html',
  styleUrls: ['./form-switch.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormElementComponent, ToggleSwitchModule, FormsModule, ReactiveFormsModule],
})
export class FormSwitchComponent extends AbstractFormElement<boolean> {}
